import type { QuestionFactoryProps } from "./types";
import type { QuestionMap } from "./questions";
import type { Groups } from "../../../../../features/questionnaire/types";

/**
 * Determines if validation events should be triggered for a question type.
 * Returns true for personalised_cover questions (parent or child).
 */
export const shouldTriggerValidationEvent = (
  display: QuestionFactoryProps["display"],
  questionName: string,
  groups: Groups,
): boolean => {
  const { type, component: displayType } = display;
  const componentType = (displayType ?? type) as keyof QuestionMap;

  // Fire for parent PersonalisedCoverQuestion
  if (componentType === "personalised_cover") {
    return true;
  }

  // Fire for child questions in personalised_cover groups
  for (const groupKey of Object.keys(groups)) {
    const group = groups[groupKey];
    if (
      group?.kind === "personalised_cover" &&
      group?.names?.includes(questionName)
    ) {
      return true;
    }
  }

  return false;
};

/**
 * Gets the group name for a question.
 * Returns the question name if it's not in a group, or the group key if it's a child question.
 */
export const getGroupName = (questionName: string, groups: Groups): string => {
  // Check if question is a child of any group
  for (const groupKey of Object.keys(groups)) {
    const group = groups[groupKey];
    if (group?.names?.includes(questionName)) {
      return groupKey; // Return the group key for child questions
    }
  }

  // Not in any group, return the question name itself
  return questionName;
};
